(function () {
  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    var root = event.target.closest('product-component') || document;
    var badge = root.querySelector('[data-pdp-pride-badge]');
    if (!badge) return;

    var amountEl = badge.querySelector('[data-pdp-donation-amount]');
    if (!amountEl) return;

    var donation = Math.round(variant.price * 0.1);

    if (window.theme && typeof window.theme.formatMoney === 'function') {
      amountEl.innerHTML = window.theme.formatMoney(
        donation,
        window.theme.moneyFormat,
      );
    }
  });
})();
